import Phaser from 'phaser';

export function getDevicePixelRatio(): number {
	if (typeof window === 'undefined') {
		return 1;
	}

	return window.devicePixelRatio || 1;
}

export function syncBouncySumsCanvasSize(game: Phaser.Game, container: HTMLElement): void {
	const fallbackWidth = typeof window === 'undefined' ? 1 : window.innerWidth;
	const fallbackHeight = typeof window === 'undefined' ? 1 : window.innerHeight;
	const width = Math.max(1, Math.round(container.clientWidth || fallbackWidth || 1));
	const height = Math.max(1, Math.round(container.clientHeight || fallbackHeight || 1));
	const devicePixelRatio = getDevicePixelRatio();

	game.canvas.style.width = `${width}px`;
	game.canvas.style.height = `${height}px`;
	game.scale.resize(
		Math.max(1, Math.round(width * devicePixelRatio)),
		Math.max(1, Math.round(height * devicePixelRatio)),
	);
}
